import { DesignListResource, DesignPageResource } from "../generated-api";
import ApiClient from "@/api/ampm-world";

export class ApiDesigners {
  static async getDesigners(lang: string): Promise<DesignListResource> {
    return ApiClient.get(`/${lang}/design`);
  }

  static async getDesignersPage(lang: string): Promise<DesignPageResource> {
    return ApiClient.get(`/${lang}/page/design`);
  }
}
